import { postRawRequest } from '../../httpClient';

export async function reconcileClipsV1Api(collectionId?: number): Promise<Response> {
  const query = collectionId === undefined ? '' : `?collectionId=${collectionId}`;
  return postRawRequest({
    path: `/sys/pipeline/reconcile-clips/v1${query}`,
    options: { timeout: 600_000 },
  });
}
